import api from "./ApiClient";

const BASE_PATH = '/foodz/api/v1/utilities';

class UtilityService {
  static async resetPassword(payload){
        const { data } = await api.post( `${BASE_PATH}/atualizar-senha`, payload);
        return data;
    }
}

export default UtilityService;